import type { FaireProductEntity } from "../../entity_types/product";

export const p_2h2s88xf69: FaireProductEntity = {
  token: "p_2h2s88xf69",
  type: "product",
  name: "Shell Pearl Fish Charm Pendant Necklace",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/288f64193009d46e82e7c37d20188c126aabba16a2c20038012bd6e766d42a5a.jpeg",
  priceDollars: 7.15,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/daaa2e233715709cb40ea97e80393752586314d20328094efcf2b90b9c964e60.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
